<template>
    <div class="news">
        <img src="../assets/img/news/picture5.jpg" />
        <!-- <div class="tab">
            <span @click="show_type = 0" :class="{active: show_type == 0}">新闻公告</span>
            <span @click="show_type = 1" :class="{active: show_type == 1}">行情新闻</span>
        </div> -->
        <div class="announcement">
            <div class="message" v-if="announcement.length > 0">温馨提示：仅显示最近20条公告记录</div>
            <a v-for="(item, index) in announcement" :key="index" class="group" :href="news_host + item.url" target="_blank">
                <p>{{item.title}}</p>
                <span>{{dataString(item.upload_dt)}}</span>
            </a>
            <i class="empty" v-if="announcement.length == 0"></i>
            <span class="empty" v-if="announcement.length == 0">新闻公告正在更新中，敬请期待</span>
        </div>
        <!-- <template  v-else>
            <div class="news-box">
                <div class="news-item" v-for="item in total" :key="item">
                    <div class="content">
                        <p class="title">美国航空宣布将于11月取消芝加哥与上海的直航……</p>
                        <p class="summary">美国航空集团21日宣布计划取消芝加哥和与上海之间的直飞航线。这是该公司今年第二次取消……</p>
                        <span class="date">2018-08-22</span>
                        <span class="more">更多</span>
                    </div>
                    <img src="../assets/img/news/news.jpg" />
                </div>
            </div>
            <pager :currentPage="current" :totalPage="totalPage"></pager>
        </template> -->
    </div>
</template>

<script>
import {post} from '@/http.js';
export default {
    // components: {
    //     pager: () => import('../components/news/pager.vue')
    // },
    data() {
        return {
            current: 1,
            total: 10,
            totalPage: 1,
            show_type: 0,
            announcement: []
        }
    },
    created() {
        // if(this.$store.state.login_phone) {
            post('query/announcements', {
                time: Date.now()
            }).then((res) => {
                this.announcement = res[0].records;
            })
        // }
        this.show_type = this.$route.params.tab || 0
        this.$root.$on('select', (tab) => {
            this.show_type = tab
        })
    },
    methods: {
        dataString(date) {
            return date.substr(0, 10)
        }
    },
    computed: {
        news_host() {
            if (process.env.NODE_ENV === 'development') {
                return 'http://10.17.31.42:8080'
            } else {
                return 'http://bops.boniuinvest.com'
            }
        }
    }
}
</script>